import React from 'react';
import './start-battle.css';


function StartBattle({firstTurn}) {
    return (
        <div className="start-battle">
            {
                firstTurn ?
                    <h3>Batalha iniciou, aguarde seu oponente escolher o ataque.</h3>
                    :
                    <h3>Aguarde seu oponente escolher a habilidade.</h3>
            }
        </div>
    );
}

export default StartBattle;